import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

/*Services */
import { TariffService } from '@services/tariff.services';
import { CachedDataService } from '@services/data/cached-data.service';
import { StateService } from '@services/state.service';
import { AppService } from '@services/app.service';

/*Models */
import { Device } from '@models/device';
import { Tariff } from '@models/tariff';

/*Plugins */
import * as moment from 'moment';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'tariffs-block',
  templateUrl: './tariffs-block.component.html',
  styleUrls: ['./tariffs-block.component.scss']
})

export class TariffsBlockComponent implements OnDestroy {
  @ViewChild('tariffModal') tariffModal;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  public currentDevice: Device;
  curentUser;
  curentPhoneUser;
  tariffs = [];
  curentTariff: Tariff;
  paymentUrl: string;

  constructor(
    private tariffService: TariffService,
    private cachedDataService: CachedDataService,
    private stateService: StateService,
    private appService: AppService
  ) {
    this.currentDevice = this.stateService.currentDevice;
    this.curentUser = this.cachedDataService.getCurrentUser();
    this.stateService.currentDeviceObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(device => {
        device = this.appService.filterHiddepPhoneDevice(device);
        this.currentDevice = device;
        this.tariffs = [];
        this.curentTariff = null;
        this.curentPhoneUser = null;
        this.paymentUrl = null;
        this.getAllTariffs();
      });
  }

  getAllTariffs() {
    this.tariffService.getInfoSim(this.curentUser.id)
      .subscribe(response => {
        if (response.data && response.data.length) {
          this.tariffs = response.data;
          this.getTariff();
        }
      },
        error => {
          console.log(error);
        }
      );
  }

  getTariff() {
    this.curentTariff = this.tariffService.getTariff(this.tariffs, this.currentDevice, this.curentUser.id);
  }

  openTariffModal(tariff) {
    this.tariffModal.open([tariff]);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/view/components/tariffs-block/tariffs-block.component.ts